import { useState, useEffect } from 'react';

const urlCache = new Set();

export const useFederatedScript = (urlKey: string) => {
  const [ready, setReady] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    const url = process.env[urlKey];

    if (!url) return;

    if (urlCache.has(url)) {
      setReady(true);
      setError(false);
      // eslint-disable-next-line no-useless-return
      return;
    }

    setReady(false);
    setError(false);

    const element = document.createElement('script');

    element.src = url;
    element.type = 'text/javascript';
    element.async = true;

    element.onload = () => {
      urlCache.add(url);
      setReady(true);
    };

    element.onerror = () => {
      setReady(false);
      setError(true);
    };

    document.head.appendChild(element);

    // eslint-disable-next-line consistent-return
    return () => {
      urlCache.delete(url);
      document.head.removeChild(element);
    };
  }, [urlKey]);

  return {
    error,
    ready,
  };
};
